import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import allowNumbersOnly, { allowAlphabetAndSpacesOnly, handlePaste } from "../../CommonUtils/CommonValidations";
import Swal from "sweetalert2";
import * as Yup from 'yup';
import { useDispatch, useSelector } from "react-redux";
import { getCollNaturelist, getDistricts, gethabitationlist, getMandals, getVillages } from "../../Reducers/AffiliationCommonservice";
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { viewImage } from "../../CommonUtils/viewImage";
import { FaEye } from "react-icons/fa";
import * as bie from "react-bootstrap";
import { ImagePdfBucket } from "../../CommonUtils/ImagesBase64";
import { ApPINCODE, ERROR_MSG, MOBILE_VALIDATION, pantanRegex } from "../../CommonUtils/contextVariables";
import { failureAlert, successAlert2 } from "../../CommonUtils/SweetAlerts";
import CommonFormHeading from "../../CommonUtils/CommonFormHeading";

export default function AfiliationApplication() {
    const hasFetchedData = useRef(false)
    const name = sessionStorage.getItem('collegeName')
    const districtmst = useSelector((state) => state?.commonMastersReducer?.DistList);
    const mandalmst = useSelector((state) => state?.commonMastersReducer?.mandalList);
    const villagemst = useSelector((state) => state?.commonMastersReducer?.villageList);
    const habitationlist = useSelector((state) => state?.commonMastersReducer?.habitationList);
    const collNatureLIST = useSelector((state) => state?.commonMastersReducer?.collNatureLIST);
    const dispatch = useDispatch();
    const instname = sessionStorage.getItem('instName'); // "college" or "ffca" or "university"


    const validationSchema = Yup.object().shape({
        collAisheCode: Yup.string().required(ERROR_MSG).nullable(),
        collNatureCode: Yup.string().required(ERROR_MSG).nullable(),
        instEstd: Yup.string().required(ERROR_MSG).nullable(),
        instName: Yup.string().required(ERROR_MSG).nullable(),
        instPan: Yup.string().matches(pantanRegex, "Invalid Pan/Tan No").required(ERROR_MSG).nullable(),
        instAddrProofType: Yup.string().required(ERROR_MSG).nullable(),
        instAddrProofPdf: Yup.string().required(ERROR_MSG).nullable(),
        instAddress: Yup.string().required(ERROR_MSG).nullable(),
        instStreet: Yup.string().required(ERROR_MSG).nullable(),
        instDistCode: Yup.string().required(ERROR_MSG).nullable(),
        instMandalCode: Yup.string().required(ERROR_MSG).nullable(),
        instVillageCode: Yup.string().required(ERROR_MSG).nullable(),
        instHabitationCode: Yup.string().required(ERROR_MSG).nullable(),
        mroOffice: Yup.string().required(ERROR_MSG).nullable(),
        instPincode: Yup.string().matches(ApPINCODE, 'Must be a valid 6-digit pincode').test('no-all-zeros', 'Pincode cannot be all zeros', value => value !== '000000').required(ERROR_MSG).nullable(),
        instLandmark: Yup.string().required(ERROR_MSG).nullable(),
        instMobile: Yup.string().matches(MOBILE_VALIDATION, 'Must be a valid mobile number').required(ERROR_MSG).nullable(),
        instEmail: Yup.string().email('Must be a valid email').required(ERROR_MSG).nullable(),
        instPhone: Yup.string().matches(/^\d{10}$/, 'Must be a valid 10-digit phone number').required(ERROR_MSG).nullable(),
        instWebsite: Yup.string().required(ERROR_MSG).nullable(),
        collegeType: Yup.string().required(ERROR_MSG).nullable(),
        instStatus: Yup.string().required(ERROR_MSG).nullable(),
        instMinority: Yup.string().required(ERROR_MSG).nullable(),

        instMinorityType: Yup.string().when('instMinority', {
            is: "true",
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired(),
        }),
        minorityStatCerti: Yup.string().when('instMinority', {
            is: "true",
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired()
        }),
        otherSpecificMinority: Yup.string().when(['instMinority', 'instMinorityType'], {
            is: (instMinority, instMinorityType) => instMinority == "true" && instMinorityType === 'OS',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired(),
        }),



        // instExamCollCode: Yup.string().required(ERROR_MSG).nullable(),
        // eamcetCode: Yup.string().required(ERROR_MSG).nullable(),
        // icetCode: Yup.string().required(ERROR_MSG).nullable(),
        competantAuthority: Yup.string().required(ERROR_MSG).nullable(),
        competantAuthorityDate: Yup.date().required(ERROR_MSG).nullable(),
        competantAuthorityPdf: Yup.string().required(ERROR_MSG).nullable(),
        isEop: Yup.string().required(ERROR_MSG).nullable(),

        latEopDateNew: Yup.date().when('isEop', {
            is: true,
            then: Yup.date()
                .nullable()
                .required(ERROR_MSG)
                .transform((value, originalValue) => (originalValue === '' ? null : value)),
            otherwise: Yup.date().notRequired(),
        }),

        latEopOrderPdfNew: Yup.string().when('isEop', {
            is: true,
            then: Yup.string()
                .nullable()
                .required(ERROR_MSG)
                .transform((value, originalValue) => (originalValue === '' ? null : value)),
            otherwise: Yup.string().notRequired(),
        }),
        automusNonautomus: Yup.string().required(ERROR_MSG).nullable(),
        ugcStatDateUpFrom: Yup.date().when('automusNonautomus', {
            is: 'A',
            then: Yup.date().required(ERROR_MSG).nullable(),
            otherwise: Yup.date().notRequired()
        }),

        ugcStatDateUpto: Yup.string().when('automusNonautomus', {
            is: 'A',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired()
        }),
        ugcYrAfflOrder: Yup.string().when('automusNonautomus', {
            is: 'A',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired()
        }),
        autoNonautoUniv: Yup.string().required(ERROR_MSG),
        univStatDateFrom: Yup.date().when('autoNonautoUniv', {
            is: 'A',
            then: Yup.date().required(ERROR_MSG).nullable(),
            otherwise: Yup.date().notRequired()
        }),
        univStatDateUpto: Yup.date().when('autoNonautoUniv', {
            is: 'A',
            then: Yup.date().required(ERROR_MSG).nullable(),
            otherwise: Yup.date().notRequired()
        }),

        universityYrAfflOrder: Yup.string().when('autoNonautoUniv', {
            is: 'A',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired()
        }),
        instUgc: Yup.string().required(ERROR_MSG).nullable(),
        instUgcType: Yup.string().when('instUgc', {
            is: 'Yes',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired()
        }),

        ugcCerti: Yup.string().when("instUgc", {
            is: (instUgc) => (instUgc === "Yes" ? true : false),
            then: Yup.string().required(ERROR_MSG).nullable(), oterwise: Yup.string(),
        }),
        naacAccredited: Yup.string().required(ERROR_MSG).nullable(),
        naacStatus: Yup.string().when('naacAccredited', {
            is: 'Yes',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired()
        }),
        naacCycle: Yup.string().when('naacAccredited', {
            is: 'Yes',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired()
        }),
        naacFromDate: Yup.date().when('naacAccredited', {
            is: 'Yes',
            then: Yup.date().required(ERROR_MSG).nullable(),
            otherwise: Yup.date().notRequired()
        }),
        naacUptoDate: Yup.date().when('naacAccredited', {
            is: 'Yes',
            then: Yup.date().required(ERROR_MSG).nullable(),
            otherwise: Yup.date().notRequired()
        }),
        naacAccredCerti: Yup.string().when('naacAccredited', {
            is: 'Yes',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired()
        }),
        naacCgpa: Yup.string().when('naacAccredited', {
            is: 'Yes',
            // then: Yup.string().required(ERROR_MSG).nullable(),
            then: Yup.string().matches(/^(?:10(\.0{1,2})?|[1-9](\.\d{1,2})?)$/, 'Invalid CGPA format').required('CGPA is required').nullable(),
            otherwise: Yup.string().notRequired()
        }),
        nbaAccrediated: Yup.string().required(ERROR_MSG).nullable(),
        nbaFromDate: Yup.date().when('nbaAccrediated', {
            is: 'Yes',
            then: Yup.date().required(ERROR_MSG).nullable(),
            otherwise: Yup.date().notRequired()
        }),
        nbaUptoDate: Yup.date().when('nbaAccrediated', {
            is: 'Yes',
            then: Yup.date().required(ERROR_MSG).nullable(),
            otherwise: Yup.date().notRequired()
        }),

        nbaAccredCerti: Yup.string().when('nbaAccrediated', {
            is: (value) => ['Yes', 'nullnull'].includes(value),
            then: Yup.string().required('required').nullable(),
            otherwise: Yup.string().notRequired().nullable(),
        }),

        nbaCgpa: Yup.string().when('nbaAccrediated', {
            is: 'Yes',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().notRequired()
        }),


    });

    const formik = useFormik({
        initialValues: {
            collNatureCode: '',
            instEstd: '',
            instName: '',
            instPan: '',
            instAddrProofType: '',
            instAddrProofPdf: '',
            instAddress: '',
            instStreet: '',
            instDistCode: '',
            instMandalCode: '',
            instVillageCode: '',
            instHabitationCode: '',
            mroOffice: '',
            instPincode: '',
            instLandmark: '',
            offCampusAddress: '',
            instMobile: '',
            instEmail: '',
            instPhone: '',
            instWebsite: '',
            collegeType: '',
            instStatus: '',
            offCampusInstStatus: '',
            instMinority: '',
            instMinorityType: '',
            otherSpecificMinority: '',
            minorityStatCerti: '',
            instExamCollCode: '',
            eamcetCode: '',
            icetCode: '',
            competantAuthority: '',
            competantAuthorityDate: '',
            competantAuthorityPdf: '',
            isEop: '',
            latEopDateNew: '',
            latEopOrderPdfNew: '',
            automusNonautomus: '',
            ugcStatDateUpFrom: '',
            ugcStatDateUpto: '',
            ugcYrAfflOrder: '',
            autoNonautoUniv: '',
            univStatDateFrom: '',
            univStatDateUpto: '',
            universityYrAfflOrder: '',
            instUgc: '',
            instUgcType: '',
            ugcCerti: '',
            naacAccredited: '',
            naacStatus: '',
            naacCycle: '',
            naacFromDate: '',
            naacUptoDate: '',
            naacAccredCerti: '',
            naacCgpa: '',
            nbaAccrediated: '',
            nbaFromDate: '',
            nbaUptoDate: '',
            nbaAccredCerti: '',
            nbaCgpa: '',
            collAisheCode: "",

        },
        validationSchema: validationSchema,
        enableReinitialize: true,
        onSubmit: (val) => {
            Swal.fire({
                title: 'Are you sure want to submit ?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Submit',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.API_URL + `AfiliationApplication`
                    CommonAxiosPost(url, val, dispatch).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            AfflApplicationData();
                        }
                        else {
                            failureAlert("Failed to submit")
                        }
                    })
                }
            })
        }
    })



    const [Application, setApplication] = useState([])
    function AfflApplicationData() {
        let url = config.url.API_URL + `getInstData`
        CommonAxiosGet(url, dispatch).then((res) => {
            if (res?.data?.scode === '01') {
                let dd = res?.data?.getLatpdf[0]
                setApplication(res?.data?.getLatpdf[0])
                const CompetantAuthorityDate = dd?.competant_authority_date && moment(dd?.competant_authority_date,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.competant_authority_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const LatEopDateNew = dd?.lat_eop_date_new && moment(dd?.lat_eop_date_new,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.lat_eop_date_new, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const ugcStatDateUpFrom = dd?.ugc_stat_date_from && moment(dd?.ugc_stat_date_from,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.ugc_stat_date_from, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const ugcStatDateUpto = dd?.ugc_stat_date_upto && moment(dd?.ugc_stat_date_upto,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.ugc_stat_date_upto, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const univStatDateFrom = dd?.univ_stat_date_from && moment(dd?.univ_stat_date_from,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.univ_stat_date_from, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const univStatDateUpto = dd?.univ_stat_date_upto && moment(dd?.univ_stat_date_upto,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.univ_stat_date_upto, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const naacFromDate = dd?.naac_from_date && moment(dd?.naac_from_date,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.naac_from_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const naacUptoDate = dd?.naac_upto_date && moment(dd?.naac_upto_date,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.naac_upto_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const nbaFromDate = dd?.nba_from_date && moment(dd?.nba_from_date,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.nba_from_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const nbaUptoDate = dd?.nba_upto_date && moment(dd?.nba_upto_date,
                    'DD/MM/YYYY', true).isValid() ? moment(dd?.nba_upto_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;

                formik?.setFieldValue("ugcStatDateUpFrom", ugcStatDateUpFrom ?? '');
                formik?.setFieldValue("collAisheCode", dd?.coll_aishe_code ?? '');

                formik?.setFieldValue("ugcStatDateUpto", ugcStatDateUpto ?? '');
                formik?.setFieldValue("univStatDateFrom", univStatDateFrom ?? '');
                formik?.setFieldValue("univStatDateUpto", univStatDateUpto ?? '');
                formik?.setFieldValue("naacFromDate", naacFromDate ?? '');
                formik?.setFieldValue("naacUptoDate", naacUptoDate ?? '');
                formik?.setFieldValue("nbaFromDate", nbaFromDate ?? '');
                formik?.setFieldValue("nbaUptoDate", nbaUptoDate ?? '');

                formik?.setFieldValue("collNatureCode", dd?.coll_nature_code);
                formik?.setFieldValue("instEstd", dd?.inst_estd);
                formik?.setFieldValue("instName", dd?.inst_name);
                formik?.setFieldValue("instPan", dd?.inst_pan);
                formik?.setFieldValue("instAddrProofType", dd?.college_type);
                if (dd?.inst_addr_proof_pdf !== null && dd?.inst_addr_proof_pdf !== undefined && dd?.inst_addr_proof_pdf !== '') {

                    formik?.setFieldValue("instAddrProofPdf", dd?.inst_addr_proof_pdf || '');
                }
                formik?.setFieldValue("instAddress", dd?.inst_address);
                formik?.setFieldValue("instStreet", dd?.inst_street);
                formik?.setFieldValue("instDistCode", dd?.inst_dist_code);
                getMandals(dd?.inst_dist_code, dispatch)

                formik?.setFieldValue("instMandalCode", dd?.inst_mandal_code);
                getVillages(dd?.inst_dist_code, dd?.inst_mandal_code, dispatch);
                formik?.setFieldValue("instVillageCode", dd?.inst_village_code);
                gethabitationlist(dd?.inst_dist_code, dd?.inst_mandal_code, dispatch);

                formik?.setFieldValue("instHabitationCode", dd?.inst_habitation_code);
                formik?.setFieldValue("mroOffice", dd?.mro_office);
                formik?.setFieldValue("instPincode", dd?.inst_pincode);
                formik?.setFieldValue("instLandmark", dd?.inst_landmark);
                formik?.setFieldValue("offCampusAddress", dd?.off_campus_address);
                formik?.setFieldValue("instMobile", dd?.inst_mobile);
                formik?.setFieldValue("instEmail", dd?.inst_email);
                formik?.setFieldValue("instPhone", dd?.inst_phone);
                formik?.setFieldValue("instWebsite", dd?.inst_website);
                formik?.setFieldValue("collegeType", dd?.college_type);
                formik?.setFieldValue("instStatus", dd?.inst_status ?? '');
                formik?.setFieldValue("offCampusInstStatus", dd?.off_campus_inst_status || '');
                formik?.setFieldValue("instMinority", dd?.inst_minority?.toString() ?? "");
                formik?.setFieldValue("instMinorityType", dd?.inst_minority_type?.toString() ?? '');
                formik?.setFieldValue("otherSpecificMinority", dd?.other_specific_minority ?? '');
                if (dd?.minority_stat_certi !== null && dd?.minority_stat_certi !== undefined && dd?.minority_stat_certi !== '') {

                    formik?.setFieldValue("minorityStatCerti", dd?.minority_stat_certi || '');
                }
                formik?.setFieldValue("instExamCollCode", dd?.inst_exam_coll_code || '');
                formik?.setFieldValue("eamcetCode", dd?.eamcet_code ?? '');
                formik?.setFieldValue("icetCode", dd?.icet_code);
                formik?.setFieldValue("competantAuthority", dd?.competant_authority);
                formik?.setFieldValue("competantAuthorityDate", CompetantAuthorityDate ?? '')
                if (dd?.competant_authority_pdf !== null && dd?.competant_authority_pdf !== undefined && dd?.competant_authority_pdf !== '') {

                    formik?.setFieldValue("competantAuthorityPdf", dd?.competant_authority_pdf || '');
                }


                if (dd?.is_eop !== null && dd?.is_eop !== undefined && dd?.is_eop !== '') {
                    formik.setFieldValue('isEop', dd.is_eop.toString() ?? '');
                }

                formik?.setFieldValue("latEopDateNew", LatEopDateNew ?? '');
                if (dd?.lat_eop_order_pdf_new !== null && dd?.lat_eop_order_pdf_new !== undefined && dd?.lat_eop_order_pdf_new !== '') {

                    formik?.setFieldValue("latEopOrderPdfNew", dd?.lat_eop_order_pdf_new ?? '');
                }
                formik?.setFieldValue("automusNonautomus", dd?.automus_nonautomus);
                if (dd?.ugc_yr_affl_order !== null && dd?.ugc_yr_affl_order !== undefined && dd?.ugc_yr_affl_order !== '') {

                    formik?.setFieldValue("ugcYrAfflOrder", dd?.ugc_yr_affl_order);
                }

                if (dd?.auto_nonauto_univ !== null && dd?.auto_nonauto_univ !== undefined && dd?.auto_nonauto_univ !== '') {
                    formik.setFieldValue('autoNonautoUniv', dd.auto_nonauto_univ.toString() ?? '');
                }


                formik?.setFieldValue("universityYrAfflOrder", dd?.university_yr_affl_order ?? '');
                formik?.setFieldValue("instUgc", dd?.inst_ugc?.toString() ?? '');
                formik?.setFieldValue("instUgcType", dd?.inst_ugc_type || '');
                if (dd?.ugc_certi !== null && dd?.ugc_certi !== undefined && dd?.ugc_certi !== '') {
                    formik?.setFieldValue("ugcCerti", dd?.ugc_certi ?? '');
                }
                formik?.setFieldValue("naacAccredited", dd?.naac_accrediated.toString() ?? '');
                formik?.setFieldValue("naacStatus", dd?.naac_status);
                formik?.setFieldValue("naacCycle", dd?.naac_cycle?.toString() ?? '');
                if (dd?.naac_accred_certi !== null && dd?.naac_accred_certi !== undefined && dd?.naac_accred_certi !== '') {
                    formik?.setFieldValue("naacAccredCerti", dd?.naac_accred_certi);
                }
                formik?.setFieldValue("naacCgpa", dd?.naac_cgpa?.toString() ?? '');
                formik?.setFieldValue("nbaAccrediated", dd?.nba_accrediated.toString() ?? '');
                if (dd?.nba_accred_certi !== null && dd?.nba_accred_certi !== undefined && dd?.nba_accred_certi !== '') {
                    formik?.setFieldValue("nbaAccredCerti", dd?.nba_accred_certi ?? '');
                }
                formik?.setFieldValue("nbaCgpa", dd?.nba_cgpa);
            }
        })
    }

    useEffect(() => {
        if (!hasFetchedData?.current) {
            getDistricts();
            getCollNaturelist();
            AfflApplicationData()
            hasFetchedData.current = true
        }

    }, [])
    return (
        <>
            <CommonFormHeading heading={`College & Approval Details For ${instname} `} />

            <FormikProvider value={formik}>
                <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit} className="affl-form">
                    <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5 " >
                        <bie.Row className="px-3 pt-4 m-0">
                            <bie.Col xs={12} sm={12} md={12} lg={5} xl={4} xxl={3}>
                                <label classname='mb-1'><b className='mt-2' style={{ color: 'red' }}>* </b><b>Nature of the college :</b></label>
                                <Field as="select" name="collNatureCode" className="form-control mb-2" >
                                    <option value=''>--SELECT--</option>
                                    {collNatureLIST !== 'No data found' && collNatureLIST?.map((ss, i) => (
                                        <option value={ss?.coll_nature_code} key={i}>{ss?.coll_nature_name}</option>
                                    ))}
                                </Field>
                                <ErrorMessage name="collNatureCode" component="div" className="text-error" />
                            </bie.Col>
                            <div className="inner-herbpage-service-title-sub"  >
                                <h1 className="mb-0">Institution Details</h1>
                            </div>
                            <div className="">
                                <bie.Row className="my-3">
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Name of the University   </label>
                                        <Field type="text" value={name} disabled name="societyHeadDist" className="form-control mb-2" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}  >
                                        {/* <bie.InputGroup> */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Year of Estd. </label>
                                        <Field name="instEstd">
                                            {({ field, form }) => (
                                                <DatePicker
                                                    selected={field.value ? new Date(field.value, 0, 1) : null}
                                                    onChange={(date) => {
                                                        const year = date ? date.getFullYear().toString() : '';
                                                        form.setFieldValue(field.name, year);
                                                    }}
                                                    showYearPicker
                                                    dateFormat="yyyy"
                                                    className="form-control mb-2"
                                                    minDate={new Date(1950, 0, 1)}
                                                    maxDate={new Date()}

                                                />
                                            )}
                                        </Field>
                                        <ErrorMessage name="instEstd" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>College Name </label>
                                        <Field type="text" name="instName" className="form-control mb-2" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e) }} maxLength="60" />
                                        <ErrorMessage name="instName" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>College PAN/TAN No</label>
                                        <Field type="text" name="instPan" className="form-control down-marg4" maxLength='10' onKeyUp={(e) => { formik.setFieldValue("instPan", e.target.value.toUpperCase()) }} />
                                        <ErrorMessage name="instPan" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Type of College Address Proof   </label>
                                        <Field as="select" name="instAddrProofType" className="form-control mb-2" >
                                            <option value=''>--SELECT--</option>
                                            <option value="Integrated">Integrated</option><option value="Standalone">Standalone</option><option value="Conventional">Conventional</option>
                                        </Field>
                                        <ErrorMessage name="instAddrProofType" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}  >
                                        {/* <bie.InputGroup> */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Upload Address Proof  </label>
                                        <div className="d-flex align-items-center">
                                            <input type="file" name="instAddrProofPdf" className="form-control down-marg4" accept="application/pdf"
                                                onChange={(e) => {
                                                    let filename = `instAddrProofPdf`;
                                                    let path = "/Uploads/AffiliationPDFs/2023/"
                                                    ImagePdfBucket(e, formik, path, `instAddrProofPdf`, filename, "pdf");
                                                }}
                                            /> &nbsp;
                                            {Application?.inst_addr_proof_pdf && <button type='button' className='btn btn-primary' onClick={() => { viewImage(Application?.inst_addr_proof_pdf) }}><FaEye size={23} /></button>}
                                        </div>



                                        <ErrorMessage name="instAddrProofPdf" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>House/Door/Plot No </label>
                                        <Field type="text" name="instAddress" className="form-control mb-2" maxLength='20' />
                                        <ErrorMessage name="instAddress" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Street/Road</label>
                                        <Field type="text" name="instStreet" className="form-control mb-2" maxLength='30' />
                                        <ErrorMessage name="instStreet" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >

                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>District </label>
                                        <Field as="select" name="instDistCode" className="form-control mb-2" onChange={(e) => {
                                            getMandals(e.target.value, dispatch)
                                            formik?.setFieldValue("instMandalCode", "")
                                            formik?.setFieldValue("instVillageCode", "")
                                            formik?.setFieldValue("instHabitationCode", "")
                                        }} >
                                            <option value=''>--SELECT--</option>
                                            {districtmst !== 'No data found' && districtmst?.map((dd, i) => (
                                                <option value={dd?.dist_code} key={i}>{dd?.dist_name}</option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="instDistCode" component="div" className="text-error" />

                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >

                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Mandal </label>
                                        <Field as="select" name="instMandalCode" className="form-control mb-2" onChange={(e) => {
                                            getVillages(formik?.values?.instDistCode, e.target.value, dispatch); gethabitationlist(formik?.values?.instDistCode, e.target.value, dispatch)
                                            formik?.setFieldValue("instVillageCode", "")
                                            formik?.setFieldValue("instHabitationCode", "")



                                        }}>
                                            <option value=''>--SELECT--</option>
                                            {mandalmst !== 'No data found' && mandalmst?.map((mm, i) => (
                                                <option value={mm?.mandal_code} key={i}>{mm?.mandal_name}</option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="instMandalCode" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >

                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Village  </label>
                                        <Field as="select" name="instVillageCode" className="form-control mb-2">
                                            <option value=''>--SELECT--</option>
                                            {villagemst !== 'No data found' && villagemst?.map((vv, i) => (
                                                <option value={vv?.village_code} key={i}>{vv?.village_name}</option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="instVillageCode" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >

                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Habitation Code  </label>
                                        <Field as="select" name="instHabitationCode" className="form-control mb-2" placeholder='habitation list'>
                                            <option value=''>--SELECT--</option>
                                            {habitationlist !== "No data found" && habitationlist?.map((vv, i) => (
                                                <option value={vv?.habitation_code} key={i}>{vv?.habitation}</option>
                                            ))}
                                        </Field>
                                        <ErrorMessage name="instHabitationCode" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Address of the MRO Office   </label>
                                        <Field type="text" name="mroOffice" className="form-control mb-2" maxLength="40" />
                                        <ErrorMessage name="mroOffice" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}  >
                                        {/* <bie.InputGroup> */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Pin Code </label>
                                        <Field type="text" name="instPincode" className="form-control mb-2" maxLength='6' onKeyPress={(e) => { allowNumbersOnly(e) }} onPaste={(e) => handlePaste(e)} />
                                        <ErrorMessage name="instPincode" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Landmark  </label>
                                        <Field type="text" name="instLandmark" className="form-control mb-2" maxLength="30" />
                                        <ErrorMessage name="instLandmark" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style">Off Campus Address</label>
                                        <Field as="textarea" name="offCampusAddress" className="form-control mb-2" maxLength="350" />

                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Mobile No   </label>
                                        <Field type="text" name="instMobile" className="form-control mb-2" maxLength='10' onKeyPress={(e) => { allowNumbersOnly(e) }} onPaste={(e) => handlePaste(e)} />
                                        <ErrorMessage name="instMobile" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}  >
                                        {/* <bie.InputGroup> */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Email ID </label>
                                        <Field type="email" name="instEmail" className="form-control mb-2" maxLength="50" />
                                        <ErrorMessage name="instEmail" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Office Landline(Phone No.)  </label>
                                        <Field type="text" name="instPhone" className="form-control mb-2" maxLength='10' onKeyPress={(e) => { allowNumbersOnly(e) }} onPaste={(e) => handlePaste(e)} />
                                        <ErrorMessage name="instPhone" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>College Website</label>
                                        <Field type="text" name="instWebsite" className="form-control mb-2" maxLength='35' />
                                        <ErrorMessage name="instWebsite" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                </bie.Row>
                            </div>
                            <div className="inner-herbpage-service-title-sub"  >
                                <h1 className="mb-0">Institution Status</h1>
                            </div>
                            <div className="">
                                <bie.Row className="my-3">
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>College Type   </label>
                                        <Field as="select" name="collegeType" className="form-control mb-2" >
                                            <option value=''>--SELECT--</option><option value="Integrated">Integrated</option><option value="Standalone">Standalone</option><option value="Conventional">Conventional</option>
                                        </Field>
                                        <ErrorMessage name="collegeType" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}  >
                                        {/* <bie.InputGroup> */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Category of the College </label>
                                        <Field as="select" name="instStatus" className="form-control mb-2" >
                                            <option value=''>--SELECT--</option><option value="Co_Education">Co-Education</option><option value="Men">Men</option><option value="Women">Women</option>
                                        </Field>
                                        <ErrorMessage name="instStatus" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style">Off Campus Category </label>
                                        <Field as="select" name="offCampusInstStatus" className="form-control mb-2" >
                                            <option value=''>--SELECT--</option>
                                            <option value="Co_Education">Co-Education</option><option value="Men">Men</option><option value="Women">Women</option>
                                        </Field>

                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Having Minority Status</label>
                                        <Field as="select" name="instMinority" className="form-control mb-2"
                                            onChange={(e) => {
                                                if (e.target.value === 'false') {
                                                    formik.setFieldValue('otherSpecificMinority', '')
                                                    formik.setFieldValue('instMinorityType', '')
                                                    formik.setFieldValue('minorityStatCerti', '')
                                                }
                                            }}>
                                            <option value=''>--SELECT--</option><option value="true">Yes</option><option value="false">No</option>
                                        </Field>
                                        <ErrorMessage name="instMinority" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    {formik?.values?.instMinority == "true" && (<>

                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Minority Type</label>
                                            <Field as="select" name="instMinorityType" className="form-control mb-2"
                                                onChange={(e) => {
                                                    if (e.target.value != 'OS') {
                                                        formik.setFieldValue('otherSpecificMinority', '')
                                                    }
                                                }}>
                                                <option value=''>--SELECT--</option><option value="MM">Muslim Minority </option><option value="LM">Linguistic Minority </option><option value="CM">Christian Minority</option><option value="OS">Others</option>
                                            </Field>
                                            <ErrorMessage name="instMinorityType" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                        {formik?.values?.instMinorityType === "OS" && (
                                            <>
                                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                                    {/* <bie.InputGroup > */}
                                                    <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>If Others, then Specify</label>
                                                    <Field type="text" name="otherSpecificMinority" className="form-control mb-2" maxLength="70" />
                                                    <ErrorMessage name="otherSpecificMinority" component="div" className="text-error" />
                                                    {/* </bie.InputGroup> */}
                                                </bie.Col></>)}
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                            {/* <bie.InputGroup > */}
                                            <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Upload Minority Certificate</label>
                                            <div className="d-flex align-items-center">
                                                <input type="file" name="minorityStatCerti" className="form-control mb-2" accept="application/pdf"
                                                    onChange={(e) => {
                                                        let filename = `minorityStatCerti`;
                                                        let path = "/Uploads/AffiliationPDFs/2023/"
                                                        ImagePdfBucket(e, formik, path, `minorityStatCerti`, filename, "pdf");
                                                    }}
                                                />
                                                {formik?.values?.minorityStatCerti && Application?.minority_stat_certi !== '' && <button type='button' className='ms-3 btn btn-primary' onClick={() => { viewImage(Application?.minority_stat_certi) }}><FaEye size={23} /></button>}
                                            </div>

                                            <ErrorMessage name="minorityStatCerti" component="div" className="text-error" />
                                            {/* </bie.InputGroup> */}
                                        </bie.Col>
                                    </>)}
                                </bie.Row>
                            </div>
                            <div className="inner-herbpage-service-title-sub"  >
                                <h1 className="mb-0">Examination & CET Details</h1>
                            </div>
                            <div className="">
                                <bie.Row className="my-3">
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style">Examination College Code</label>
                                        <Field type="text" name="instExamCollCode" className="form-control mb-2" maxLength="15" />
                                        {/* <ErrorMessage name="instExamCollCode" component="div" className="text-error" /> */}
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}  >
                                        {/* <bie.InputGroup> */}
                                        <label classname='mb-1' className="label-text-style">EAMCET Code </label>
                                        <Field type="text" name="eamcetCode" className="form-control mb-2" maxLength="15" />
                                        {/* <ErrorMessage name="eamcetCode" component="div" className="text-error" /> */}
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style">ICET Code </label>
                                        <Field type="text" name="icetCode" className="form-control mb-2" maxLength="15" />
                                        {/* <ErrorMessage name="icetCode" component="div" className="text-error" /> */}
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                </bie.Row>
                            </div>
                        </bie.Row>
                        <bie.Row>
                            <bie.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="mt-2">
                                <div className="inner-herbpage-service-title1">
                                    <h1>Approvals</h1>
                                </div>
                            </bie.Col>
                        </bie.Row>
                        <bie.Row className="px-3 pt-2 m-0 ">
                            <div className="inner-herbpage-service-title-sub"  >
                                <h1 className="mb-0">Approvals-Competent Authority (APSCHE/AICTE/PCI/BCI/NCTE)</h1>
                            </div>
                            <div className="">
                                <bie.Row className="my-3">
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Competant Authority for Approval</label>
                                        <Field type="text" name="competantAuthority" className="form-control mb-2" maxLength="30" />
                                        <ErrorMessage name="competantAuthority" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}  >
                                        {/* <bie.InputGroup> */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Date of Initial Permission </label>
                                        <Field type="date" name="competantAuthorityDate" className="form-control down-marg4" onKeyDown={(e) => { e.preventDefault() }} />
                                        <ErrorMessage name="competantAuthorityDate" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        {/* <bie.InputGroup > */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Upload Initial Permission Order </label>
                                        <div className="d-flex align-items-center">
                                            <input type="file" name="competantAuthorityPdf" className="form-control mb-2" accept="application/pdf"
                                                onChange={(e) => {
                                                    let filename = `competantAuthorityPdf`;
                                                    let path = "/Uploads/AffiliationPDFs/2023/"
                                                    ImagePdfBucket(e, formik, path, `competantAuthorityPdf`, filename, "pdf");
                                                }}
                                            /> &nbsp;
                                            {Application?.competant_authority_pdf && <button type='button' className='ms-3 btn btn-primary' onClick={() => { viewImage(Application?.competant_authority_pdf) }}><FaEye className="icon" size={23} /></button>}

                                        </div>
                                        <ErrorMessage name="competantAuthorityPdf" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                </bie.Row>
                                <bie.InputGroup className="d-flex align-items-center px-2">

                                    <bie.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                        <label classname='mb-1'><b style={{ color: 'red' }}>* </b> <b className="me-3">Any change in Address after the issuance of the Initial Establishment Order Yes/No : </b></label>
                                        <Field type='radio' name="isEop" value='true' className="mx-2" />
                                        <label classname='mb-1' className="me-3">Yes</label>
                                        <Field type='radio' name="isEop" value='false' className="mx-2"
                                            onChange={() => {
                                                formik?.setFieldValue('latEopDateNew', '')
                                                formik?.setFieldValue('latEopOrderPdfNew', '')
                                            }}
                                        />

                                        <label classname='mb-1' className="me-3">No</label>
                                        <ErrorMessage name='isEop' className='text-error' component='div' />

                                    </bie.Col>

                                </bie.InputGroup>
                                {formik.values.isEop === 'true' && (
                                    <bie.Row className="pt-4 m-0 ">

                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                            <label classname='mb-1' ><b style={{ color: 'red' }}>* </b>Date of Permission for change of address : </label>
                                            <Field type="date" name="latEopDateNew" className="form-control mb-2" onKeyDown={(e) => { e.preventDefault() }} min="1970-01-01" max={new Date().toISOString().split('T')[0]} />
                                            <ErrorMessage name="latEopDateNew" component="div" className="text-error" />
                                        </bie.Col>

                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}  >
                                            <label classname='mb-1' ><b style={{ color: 'red' }}>* </b>Upload Permission proceedings : </label>
                                            <input type="file" name="latEopOrderPdfNew" className="form-control mb-2" accept="application/pdf"
                                                onChange={(e) => {
                                                    let filename = `latEopOrderPdfNew`;
                                                    let path = "/Uploads/AffiliationPDFs/2023/"
                                                    ImagePdfBucket(e, formik, path, `latEopOrderPdfNew`, filename, "pdf");
                                                }}
                                            />
                                            <ErrorMessage name="latEopOrderPdfNew" component="div" className="text-error" />
                                        </bie.Col>
                                        <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}  >
                                            {formik?.values?.latEopOrderPdfNew && Application?.lat_eop_order_pdf_new && <button type='button' className='btn btn-primary' style={{ marginTop: "15%" }} onClick={() => { viewImage(Application?.lat_eop_order_pdf_new) }}><FaEye size={23} /></button>}

                                        </bie.Col>


                                    </bie.Row>
                                )}
                            </div>
                            <div className="inner-herbpage-service-title-sub"  >
                                <h1 className="mb-0">Autonomous Status by UGC</h1>
                            </div>
                            <div className=" py-3">
                                <bie.Row className="  m-0  ">
                                    <bie.Col xs={12} sm={12} md={12} lg={12} xl={5} xxl={3} >
                                        <label><b style={{ color: 'red' }}>* </b> Status By UGC</label>
                                        <div className="">
                                            <div className="form-control">
                                                <Field type="radio" name="automusNonautomus" value='A' />&nbsp;&nbsp;Autonomous&nbsp;&nbsp;
                                                <Field type="radio" name="automusNonautomus" value='N'
                                                    onClick={() => {
                                                        formik.setFieldValue('ugcStatDateUpFrom', '')
                                                        formik.setFieldValue('ugcStatDateUpto', '')
                                                        formik.setFieldValue('ugcYrAfflOrder', '')
                                                    }}
                                                />&nbsp;&nbsp;Non-Autonomous
                                            </div>
                                            <ErrorMessage name="automusNonautomus" component="div" className="text-error" />
                                        </div>
                                    </bie.Col>
                                    {formik?.values?.automusNonautomus === 'A' && (
                                        <>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}  >
                                                {/* <bie.InputGroup> */}
                                                <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Valid From Date </label>
                                                <Field type="date" name="ugcStatDateUpFrom" className="form-control mb-2" onClick={() => formik.setFieldValue('ugcStatDateUpto', '')} onKeyDown={(e) => { e.preventDefault() }} />
                                                <ErrorMessage name="ugcStatDateUpFrom" component="div" className="text-error" />
                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                                {/* <bie.InputGroup > */}
                                                <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Valid Till Date  </label>
                                                <Field type="date" name="ugcStatDateUpto" className="form-control mb-2" min={formik.values.ugcStatDateUpFrom} onKeyDown={(e) => { e.preventDefault() }} />
                                                <ErrorMessage name="ugcStatDateUpto" component="div" className="text-error" />
                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} classname='mb-3  '>
                                                {/* <bie.InputGroup > */}
                                                <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Upload UGC Issued Order </label>
                                                <input type="file" name="ugcYrAfflOrder" className="form-control mb-2" accept="application/pdf"
                                                    onChange={(e) => {
                                                        let filename = `ugcYrAfflOrder`;
                                                        let path = "/Uploads/AffiliationPDFs/2023/"
                                                        ImagePdfBucket(e, formik, path, `ugcYrAfflOrder`, filename, "pdf");
                                                    }}
                                                />
                                                <ErrorMessage name="ugcYrAfflOrder" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}  >

                                                {formik?.values?.ugcYrAfflOrder && Application?.ugc_yr_affl_order && <button type='button' className='btn btn-primary' style={{ marginTop: "15%" }} onClick={() => { viewImage(Application?.ugc_yr_affl_order) }}><FaEye size={23} /></button>}

                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                        </>
                                    )}
                                </bie.Row>
                            </div>
                            <div className="inner-herbpage-service-title-sub"  >
                                <h1 className="mb-0">Autonomous Status by University</h1>
                            </div>
                            <div className=" py-3">
                                <bie.Row className=" m-0  ">
                                    <bie.Col xs={12} sm={12} md={12} lg={12} xl={5} xxl={3} >
                                        <label><b style={{ color: 'red' }}>* </b>Status by University</label>
                                        <div className="form-control">
                                            <Field type="radio" name="autoNonautoUniv" value='A' />&nbsp;&nbsp;Autonomous&nbsp;&nbsp;
                                            <Field type="radio" name="autoNonautoUniv" value='N'
                                            // onClick={() => {
                                            //     formik.setFieldValue('univStatDateFrom', '')
                                            //     formik.setFieldValue('univStatDateUpto', '')
                                            //     formik.setFieldValue('universityYrAfflOrder', '')
                                            // }}
                                            />Non-Autonomous
                                        </div>
                                        <ErrorMessage name="autoNonautoUniv" component="div" className="text-error" />
                                    </bie.Col>
                                    {formik?.values?.autoNonautoUniv === 'A' && (
                                        <>
                                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={2}  >
                                                {/* <bie.InputGroup> */}
                                                <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Valid From Date </label>
                                                <Field type="date" name="univStatDateFrom" className="form-control down-marg4" onClick={() => { formik.setFieldValue('univStatDateUpto', '') }} onKeyDown={(e) => { e.preventDefault() }} />
                                                <ErrorMessage name="univStatDateFrom" component="div" className="text-error" />
                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={2} >
                                                {/* <bie.InputGroup > */}
                                                <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Valid Till Date  </label>
                                                <Field type="date" name="univStatDateUpto" className="form-control down-marg4" min={formik.values.univStatDateFrom} onKeyDown={(e) => { e.preventDefault() }} />
                                                <ErrorMessage name="univStatDateUpto" component="div" className="text-error" />
                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3 '>
                                                {/* <bie.InputGroup > */}
                                                <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Upload University Issued Order </label>
                                                <input type="file" name="universityYrAfflOrder" className="form-control mb-2" accept="application/pdf"
                                                    onChange={(e) => {
                                                        let filename = `universityYrAfflOrder`;
                                                        let path = "/Uploads/AffiliationPDFs/2023/"
                                                        ImagePdfBucket(e, formik, path, `universityYrAfflOrder`, filename, "pdf");
                                                    }}
                                                />
                                                <ErrorMessage name="universityYrAfflOrder" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} classname='mb-3 '>


                                                {formik?.values?.universityYrAfflOrder && Application?.university_yr_affl_order && <button type='button' className='btn btn-primary' style={{ marginTop: "15%" }} onClick={() => { viewImage(Application?.university_yr_affl_order) }}><FaEye size={23} /></button>}

                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                        </>
                                    )}
                                </bie.Row>
                            </div>
                            <div className="inner-herbpage-service-title-sub"  >
                                <h1 className="mb-0">UGC recognition Details</h1>
                            </div>
                            <div className=" py-3">
                                <bie.Row className="px-2  m-0  ">
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={5} xxl={3}  >
                                        {/* <bie.InputGroup> */}
                                        <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Whether the College has 2(f) & 12B or Both </label>
                                        <Field as="select" name="instUgc" className="form-control mb-2"
                                            onChange={(e) => {
                                                if (e.target.value === 'No') {
                                                    formik.setFieldValue('instUgcType', '')
                                                    formik.setFieldValue('ugcCerti', '')
                                                }
                                            }}>
                                            <option value=''>--SELECT--</option><option value="Yes">Yes</option><option value="No">No</option>
                                        </Field>
                                        <ErrorMessage name="instUgc" component="div" className="text-error" />
                                        {/* </bie.InputGroup> */}
                                    </bie.Col>
                                    {formik?.values?.instUgc == 'Yes' && (
                                        <>
                                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={3} xxl={3} >
                                                {/* <bie.InputGroup > */}
                                                <label classname='mb-1' className="label-text-style affl-downmarg"><b style={{ color: 'red' }}>* </b>Type   </label>
                                                <Field as="select" name="instUgcType" className="form-control down-marg4" >
                                                    <option value=''>--SELECT--</option>
                                                    <option value="1">2(f) alone</option>
                                                    <option value="2">12B alone</option>
                                                    <option value="3">Both (2(f) & 12B)</option>
                                                </Field>
                                                <ErrorMessage name="instUgcType" component="div" className="text-error" />
                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3 ,t-4 '>
                                                {/* <bie.InputGroup > */}
                                                <label classname='mb-1' className="label-text-style affl-downmarg"><b style={{ color: 'red' }}>* </b>Upload UGC Certificate </label>
                                                <input type="file" name="ugcCerti" className="form-control down-marg4" accept="application/pdf"
                                                    onChange={(e) => {
                                                        let filename = `ugcCerti`;
                                                        let path = "/Uploads/AffiliationPDFs/2023/"
                                                        ImagePdfBucket(e, formik, path, `ugcCerti`, filename, "pdf");
                                                    }} />&emsp;

                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}  >

                                                {formik?.values?.ugcCerti && Application?.ugc_certi && <button type='button' className='btn btn-primary' style={{ marginTop: "15%" }} onClick={() => { viewImage(Application?.ugc_certi) }}><FaEye size={23} /></button>}

                                                <ErrorMessage name="ugcCerti" component="div" className="text-error" />
                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                        </>
                                    )}
                                </bie.Row>
                            </div>


                            <div className="inner-herbpage-service-title-sub"  >
                                <h1 className="mb-0">College Aishe Code</h1>
                            </div>

                            <div className=" py-3 mb-3">
                                <bie.Row className=" pt-4 m-0 ">
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        <label classname='mb-1' className="label-text-style">
                                            <b style={{ color: 'red' }}>* </b>College Aishe Code
                                        </label>
                                        <Field type="text" name="collAisheCode" className="form-control down-marg4" maxLength="8" />
                                        <ErrorMessage name="collAisheCode" component="div" className="text-error" />
                                    </bie.Col>

                                </bie.Row>
                            </div>


                            <div className="inner-herbpage-service-title-sub"  >
                                <h1 className="mb-0">College Accreditation Details</h1>
                            </div>
                            <div className=" py-3 mb-3">
                                <bie.Row className=" pt-4 m-0 ">
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-4'>
                                        <label classname='mb-1' ><b style={{ color: 'red' }}>* </b><b>Whether Accredited by NAAC :</b></label>
                                        <Field as="select" name="naacAccredited" className="form-control mb-2"
                                            onChange={(e) => {
                                                if (e.target.value === 'A' || e.target.value === 'No') {
                                                    formik.setFieldValue('naacStatus', '')
                                                    formik.setFieldValue('naacCycle', '')
                                                    formik.setFieldValue('naacFromDate', '')
                                                    formik.setFieldValue('naacUptoDate', '')
                                                    formik.setFieldValue('naacAccredCerti', '')
                                                    formik.setFieldValue('naacCgpa', '')
                                                    document.getElementById("naacAccredCerti").value = null;

                                                }
                                            }}>

                                            <option value=''>--SELECT--</option><option value="Yes">Conferred</option><option value="A">Applied</option><option value="No">Not Yet Applied</option>
                                        </Field>
                                        <ErrorMessage name="naacAccredited" component="div" className="text-error" />
                                    </bie.Col>
                                    {formik?.values?.naacAccredited === 'Yes' && (
                                        <>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                                {/* <bie.InputGroup > */}
                                                <label classname='mb-1' className="label-text-style">
                                                    <b style={{ color: 'red' }}>* </b>NAAC Grade
                                                </label>
                                                <Field type="text" name="naacStatus" className="form-control down-marg4" maxLength="5" />
                                                <ErrorMessage name="naacStatus" component="div" className="text-error" />
                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                                {/* <bie.InputGroup > */}
                                                <label classname='mb-1' className="label-text-style">
                                                    <b style={{ color: 'red' }}>* </b>NAAC Cycle
                                                </label>
                                                <Field as="select" name="naacCycle" className="form-control down-marg4">
                                                    <option value=''>--SELECT--</option>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                </Field>
                                                <ErrorMessage name="naacCycle" component="div" className="text-error" />
                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                                {/* <bie.InputGroup> */}
                                                <label classname='mb-1' className="label-text-style">
                                                    <b style={{ color: 'red' }}>* </b>NAAC Valid From Date
                                                </label>
                                                <Field type="date" name="naacFromDate" className="form-control down-marg4" onClick={() => formik.setFieldValue('naacUptoDate', '')} onKeyPress={(e) => { e.preventDefault() }} />
                                                <ErrorMessage name="naacFromDate" component="div" className="text-error" />
                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                                {/* <bie.InputGroup> */}
                                                <label classname='mb-1' className="label-text-style">
                                                    <b style={{ color: 'red' }}>* </b>NAAC Valid Till Date
                                                </label>
                                                <Field type="date" name="naacUptoDate" className="form-control down-marg4" min={formik?.values?.naacFromDate} onKeyPress={(e) => { e.preventDefault() }} />
                                                <ErrorMessage name="naacUptoDate" component="div" className="text-error" />
                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} >
                                                {/* <bie.InputGroup> */}
                                                <label classname='mb-1' className="label-text-style">
                                                    <b style={{ color: 'red' }}>* </b>Upload NAAC Accreditation Certificate
                                                </label>
                                                <input type="file" name="naacAccredCerti" className="form-control mb-2" accept="application/pdf"
                                                    onChange={(e) => {
                                                        let filename = `naacAccredCerti`;
                                                        let path = "/Uploads/AffiliationPDFs/2023/"
                                                        ImagePdfBucket(e, formik, path, `naacAccredCerti`, filename, "pdf");
                                                    }}
                                                />
                                                <ErrorMessage name="naacAccredCerti" component="div" className="text-error" />
                                            </bie.Col>

                                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}  >

                                                {formik?.values?.naacAccredCerti && Application?.naac_accred_certi && Application.naac_accred_certi.trim() !== 'nullnull' && (
                                                    <button type="button" className=" btn btn-primary" style={{ marginTop: "15%" }} onClick={() => { viewImage(Application.naac_accred_certi); }}>
                                                        <FaEye size={23} />
                                                    </button>
                                                )}


                                                {/* </bie.InputGroup> */}
                                            </bie.Col>

                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                                {/* <bie.InputGroup> */}
                                                <label classname='mb-1' className="label-text-style">
                                                    <b style={{ color: 'red' }}>* </b>NAAC CGPA
                                                </label>
                                                <Field type="text" name="naacCgpa" className="form-control mb-2" maxLength="4"
                                                // onPaste={(e) => preventZeroInputAndPaste(e)} onKeyPress={(e) => { allowNumbersOnly(e) }}
                                                />
                                                <ErrorMessage name="naacCgpa" component="div" className="text-error" />
                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                        </>
                                    )}
                                </bie.Row>
                                <bie.Row className="pt-3 m-0  ">
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-5'>
                                        <label classname='mb-1' ><b style={{ color: 'red' }}>* </b><b>Whether Accredited by NBA :</b></label>
                                        <Field as="select" name="nbaAccrediated" className="form-control mb-2"
                                            onChange={(e) => {
                                                if (e.target.value === 'A' || e.target.value === 'No') {
                                                    formik?.setFieldValue('nbaFromDate', '')
                                                    formik?.setFieldValue('nbaUptoDate', '')
                                                    formik?.setFieldValue('nbaAccredCerti', '')
                                                    formik?.setFieldValue('nbaCgpa', '')
                                                    document.getElementById("nbaAccredCerti").value = null;

                                                }
                                            }}>
                                            <option value=''>--SELECT--</option><option value="Yes">Conferred</option><option value="A">Applied</option><option value="No">Not Yet Applied</option>
                                        </Field>
                                        <ErrorMessage name="nbaAccrediated" component="div" className="text-error" />
                                    </bie.Col>
                                    {formik?.values?.nbaAccrediated === 'Yes' && (
                                        <>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}  >
                                                {/* <bie.InputGroup> */}
                                                <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>NBA Valid From Date </label>
                                                <Field type="date" name="nbaFromDate" className="form-control down-marg4" onClick={() => formik.setFieldValue('nbaUptoDate', '')} onKeyDown={(e) => { e.preventDefault() }} />
                                                <ErrorMessage name="nbaFromDate" component="div" className="text-error" />
                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-4 mt-4'>
                                                {/* <bie.InputGroup > */}
                                                <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>NBA Valid Till Date </label>
                                                <Field type="date" name="nbaUptoDate" className="form-control down-marg4" min={formik?.values?.nbaFromDate} onKeyDown={(e) => { e.preventDefault() }} />
                                                <ErrorMessage name="nbaUptoDate" component="div" className="text-error" />
                                                {/* </bie.InputGroup> */}
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} classname='mb-4 mt-4'>
                                                {/* <bie.InputGroup > */}
                                                <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>Upload NBA Accreditation Certificate </label>
                                                <input type="file" name="nbaAccredCerti" className="form-control mb-2" accept="application/pdf"
                                                    onChange={(e) => {
                                                        let filename = `nbaAccredCerti`;
                                                        let path = "/Uploads/AffiliationPDFs/2023/"
                                                        ImagePdfBucket(e, formik, path, `nbaAccredCerti`, filename, "pdf");
                                                    }}
                                                />
                                                <ErrorMessage name="nbaAccredCerti" component="div" className="text-error" />
                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}  >



                                                {formik?.values?.nbaAccredCerti && Application?.nba_accred_certi && Application.nba_accred_certi.trim() !== 'nullnull' && (
                                                    <button type="button" className=" btn btn-primary" style={{ marginTop: "15%" }} onClick={() => { viewImage(Application.nba_accred_certi); }}>
                                                        <FaEye size={23} />
                                                    </button>
                                                )}



                                                {/* </bie.InputGroup> */}

                                            </bie.Col>
                                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-4 mt-4'>
                                                {/* <bie.InputGroup > */}
                                                <label classname='mb-1' className="label-text-style"><b style={{ color: 'red' }}>* </b>NBA Marks</label>
                                                <Field type="text" name="nbaCgpa" className="form-control down-marg4" onKeyPress={(e) => { allowNumbersOnly(e) }} maxLength="4" onPaste={(e) => handlePaste(e)} />
                                                <ErrorMessage name="nbaCgpa" component="div" className="text-error" />
                                                {/* </bie.InputGroup> */}
                                            </bie.Col>

                                        </>)}
                                </bie.Row>
                            </div>

                        </bie.Row>
                        <pre /><pre />  <button type='submit' className='btn btn-success btn-sm float-end'>Submit</button><pre />
                    </bie.Container>
                </Form>
            </FormikProvider>
        </>
    )
}